const reRegExpChar = /[\\^$.*+?()[\]{}|]/g
export default reRegExpChar
